import { getCookie } from "../util/cookies";
import { logFrontEndError } from "@lululemon/ecom-site-utils/src/logger/utils";

export function getUsrLocale(ctx) {
  // Priority 1: locale from context
  const locale = ctx?.locale?.lang;
  if (locale) return locale;

  // Priority 2: Cookie fallback (during transition period only)
  const cookieLocale = getCookie("UsrLocale", ctx?.req);
  if (cookieLocale) {
    logFrontEndError({
      type: "info",
      message: "Using UsrLocale cookie fallback - migrate to Next.js locale",
      functionName: "getUsrLocale"
    });
    return cookieLocale.replace("_", "-");
  }

  // Final fallback
  return "en-US";
}
